import useSWR from "swr";
import moment from "moment";
import { endpointsSpeckle } from "../actions/endpointsSpeckle";
import { fetcher } from "lib/actions/fetcher";
import { SpeckleVersionModel } from "../../SpeckleImportWizard/types/SpeckleVersionModel";

export function useSpeckleVersions(
  speckleConnectedAccountId: number,
  speckleProjectId: string,
  speckleModelId: string,
) {
  const {
    data: versions,
    error,
    isLoading,
    mutate,
  } = useSWR(
    speckleConnectedAccountId &&
      speckleProjectId &&
      speckleModelId &&
      endpointsSpeckle.versions(
        speckleConnectedAccountId,
        speckleProjectId,
        speckleModelId,
      ),
    (url) =>
      fetcher<SpeckleVersionModel[]>(url).then(
        (data) =>
          data && data.map((v) => ({ ...v, createdOn: moment(v.createdOn) })),
      ),
  );

  async function refresh() {
    await mutate();
  }

  return {
    versions,
    hasError: !!error,
    isLoading,
    refresh,
  };
}
